import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpModule, Http, RequestOptions} from '@angular/http';
import {AppRoutingModule} from './app-routing.module';
import {AuthHttp, AuthConfig} from 'angular2-jwt';
import {AuthenticationService} from './auth/authentication.service';
import {AuthGuard} from './auth/auth-guard.service';
import {ValidationService} from './common/validation.service';
import {NgxPaginationModule} from 'ngx-pagination';
import {CustomFormsModule} from 'ng2-validation';
import {FileUploadModule} from "ng2-file-upload";
import {ChartsModule} from 'ng2-charts';
import { Ng2FilterPipeModule } from 'ng2-filter-pipe';
import { Uploader } from 'angular2-http-file-upload';
import { CKEditorModule } from 'ng2-ckeditor';
import { TextMaskModule } from 'angular2-text-mask';
import { MyDatePickerModule } from 'mydatepicker';
import {DpDatePickerModule} from 'ng2-date-picker';


import {BrowserAnimationsModule, NoopAnimationsModule} from '@angular/platform-browser/animations';
import 'hammerjs';
import {MyMaterialModule} from './common/my-material.module';

import {AppComponent} from './app.component';
import {SupplierHeaderComponent} from './supplier/header/header.component';
import {SupplierFooterComponent} from './supplier/footer/footer.component';
import {SupplierRegistrationComponent} from './supplier/registration/registration.component';
import {DistributorRegistrationComponent} from './distributor/registration/registration.component';
import {GuestRegistrationComponent} from './guest/registration/registration.component';
import {HomeHeaderComponent} from './home/header/header.component';
import {HomeFooterComponent} from './home/footer/footer.component';
import {HomeComponent} from './home/home/home.component';
import {EventSponsorshipComponent} from './admin/event-sponsorship/event-sponsorship.component';
import {EventListingComponent} from './home/event-listing/event-listing.component';
import {LoginComponent} from './home/login/login.component';
import {DistributorProfileComponent} from './distributor/profile/profile/profile.component';
import {DistributorHeaderComponent} from './distributor/header/header.component';
import {DistributorFooterComponent} from './distributor/footer/footer.component';
import {GuestHeaderComponent} from './guest/header/header.component';
import {GuestFooterComponent} from './guest/footer/footer.component';
import {SupplierSettingsComponent} from './supplier/profile/settings/settings.component';
import {SupplierDashboardComponent} from './supplier/profile/dashboard/dashboard.component';
import {SupplierEventDetailComponent} from './supplier/profile/event-detail/event-detail.component';
import {CheckPaymentComponent} from './admin/check-payment/check-payment.component';
import {EmailSentToComponent} from './admin/email/email-sent-to/email-sent-to.component';
import {SupplierActivityFormComponent} from './supplier/profile/activity-form/activity-form.component';
import {DistributorActivityFormComponent} from './distributor/profile/activity-form/activity-form.component';
import {SupplierFeatureFormComponent} from './supplier/profile/feature-form/feature-form.component';
import {DistributorFeatureFormComponent} from './distributor/profile/feature-form/feature-form.component';
import {AdminTravelInfoFormComponent} from './admin/travel-info-form/travel-info-form.component';
import {AdminAddressFormComponent} from './admin/address-form/address-form.component';
import {AdminTravelDetailFormComponent} from './admin/travel-detail-form/travel-detail-form.component';
import {AdminLeisureFormComponent} from './admin/leisure-form/leisure-form.component';
import {SendMailComponent} from './admin/email/send-mail/send-mail.component';
import {ApproveRefundComponent} from './admin/approve-refund/approve-refund.component';
import {EditAdminProfileComponent} from './admin/profile/edit/edit-admin-profile.component';
import {ChangeAdminPasswordComponent} from './admin/profile/change-password/change-admin-password.component';
import {EmailInvitationFormComponent} from './admin/email/invitation-form/email-invitation-form.component';
import {EmailContactFormComponent} from './admin/email/contact-form/email-contact-form.component';
import {EventPageFormComponent} from './admin/event-page-form/event-page-form.component';
import {SupplierMembershipFormComponent} from './admin/supplier-membership-form/supplier-membership-form.component';
import {ActivityLimitFormComponent} from './admin/activity-limit-form/activity-limit-form.component';
import {FeatureLimitFormComponent} from './admin/feature-limit-form/feature-limit-form.component';
import {PackageActivityLimitsComponent} from './admin/package-activity-limits/package-activity-limits.component';
import {PackageFeatureLimitsComponent} from './admin/package-feature-limits/package-feature-limits.component';
import {DistributorMembershipFormComponent} from './admin/distributor-membership-form/distributor-membership-form.component';
import {GuestMembershipFormComponent} from './admin/guest-membership-form/guest-membership-form.component';
import {EventFeatureFormComponent} from './admin/event-feature-form/event-feature-form.component';
import {FeatureOptionsComponent} from './admin/feature-options/feature-options.component';
import {FeatureOptionFormComponent} from './admin/feature-option-form/feature-option-form.component';
import {ActivityQuestionsComponent} from './admin/activity-questions/activity-questions.component';
import {ActivityQuestionFormComponent} from './admin/activity-question-form/activity-question-form.component';
import {ActivityQuestionOptionsComponent} from './admin/activity-question-options/activity-question-options.component';
import {ActivityQuestionOptionFormComponent} from './admin/activity-question-option-form/activity-question-option-form.component';
import {CardFormComponent} from './card-form/card-form.component';
import {DeleteAttendeeWarningComponent} from './delete-attendee-warning/delete-attendee-warning.component';
import {PayBalanceComponent} from './pay-balance/pay-balance.component';
import {SupplierProfileComponent} from './supplier/profile/profile/profile.component';
import {AddAttendeeComponent} from './admin/add-attendee/add-attendee.component';
import { CancelAttendeeComponent } from './admin/cancel-attendee/cancel-attendee.component';
import { AddDiscountComponent } from './admin/add-discount/add-discount.component';
import { PayBalanceAdminComponent } from './admin/pay-balance-admin/pay-balance-admin.component';
import { SupplierAttendeeFormComponent } from './supplier/profile/attendee-form/attendee-form.component';
import { DistributorAttendeeFormComponent } from './distributor/profile/attendee-form/attendee-form.component';
import { EditSupplierAttendeeComponent } from './supplier/profile/edit-attendee/edit-attendee.component';
import { EditDistributorAttendeeComponent } from './distributor/profile/edit-attendee/edit-attendee.component';

import { EditTravelComponent } from './edit-travel/edit-travel.component';
import { AdminEditAttendeeComponent } from './admin/admin-edit-attendee/admin-edit-attendee.component';
import { DistributorEditActivityComponent } from './admin/distributor-edit-activity/distributor-edit-activity.component';
import { AttendeesReportComponent } from './admin/attendees-report/attendees-report.component';
import { SupplierEditActivityComponent } from './admin/supplier-edit-activity/supplier-edit-activity.component';
import { AdminEditTravelInfoComponent } from './admin/admin-edit-travel-info/admin-edit-travel-info.component';
import { AttendeeEditActivityComponent } from './admin/attendee-edit-activity/attendee-edit-activity.component';
import { AdminFeatureEditComponent } from './admin/admin-feature-edit/admin-feature-edit.component';
import { FiltersPipe } from './filters.pipe';
import { AdminFullCancelComponent } from './admin/admin-full-cancel/admin-full-cancel.component';
import { GuestProfileComponent } from './guest/profile/profile/profile.component';
import { GuestAttendeeFormComponent } from './guest/profile/attendee-form/attendee-form.component';
import { EditGuestAttendeeComponent } from './guest/profile/edit-attendee/edit-attendee.component';
import { GuestActivityFormComponent } from './guest/profile/activity-form/activity-form.component';
import { EmailMessageComponent } from './admin/email/email-message/email-message.component';
import { GuestEditActivityComponent } from './admin/guest-edit-activity/guest-edit-activity.component';
import { CategoryPopUpComponent } from './admin/categories/category-pop-up/category-pop-up.component';
import { TripRegistrationComponent } from './trip/registration/registration.component';
import { TripAddAttendeeComponent } from './admin/trip/trip-add-attendee/trip-add-attendee.component';
import { TripEditAttendeeComponent } from './admin/trip/trip-edit-attendee/trip-edit-attendee.component';
import { TripEditTravelComponent } from './admin/trip/trip-edit-travel/trip-edit-travel.component';
import { EscapeHtmlPipe } from './pipes/keep-html.pipe';
import { TripEditActivityComponent } from './admin/trip/trip-edit-activity/trip-edit-activity.component';
import { EditHotelCheckInOutComponent } from './admin/trip/edit-hotel-check-in-out/edit-hotel-check-in-out.component';
import { FeedbackSentToComponent } from './admin/profile/feedback-sent-to/feedback-sent-to.component';
import { SupplierRegTypesComponent } from './home/supplier-reg-types/supplier-reg-types.component';
import { PurchaseOrderManualEntryFormComponent } from './admin/purchase-orders/purchase-order-manual-entry-form/purchase-order-manual-entry-form.component';
import { GlobalPageFormComponent } from './admin/global-page-form/global-page-form.component';
import { AdminpackUpgradeComponent } from './adminpack-upgrade/adminpack-upgrade.component';

export function authHttpServiceFactory(http: Http, options: RequestOptions) {

    var x = new Date();
    var offsetInMin = x.getTimezoneOffset();
    var offset = (offsetInMin >= 0 ? "-" : "+") + ('0' + (Math.floor(Math.abs(offsetInMin) / 60))).slice(-2) + ':' + Math.floor(Math.abs(Math.ceil(offsetInMin * 10 / 60)) / 1.666666666);

    return new AuthHttp(new AuthConfig({
        tokenName: 'token',
        tokenGetter: (() => sessionStorage.getItem('token')),
        globalHeaders: [{'Accept': 'application/json'}, {'timeZone': offset}],
    }), http, options);
}

@NgModule({
    declarations: [
        AppComponent,
        SupplierHeaderComponent,
        SupplierFooterComponent,
        SupplierRegistrationComponent,
        DistributorRegistrationComponent,
        GuestRegistrationComponent,
        HomeHeaderComponent,
        HomeFooterComponent,
        HomeComponent,
        EventSponsorshipComponent,
        EventListingComponent,
        LoginComponent,
        DistributorProfileComponent,
        GuestProfileComponent,
        DistributorHeaderComponent,
        DistributorFooterComponent,
        GuestHeaderComponent,
        GuestFooterComponent,
        SupplierSettingsComponent,
        SupplierDashboardComponent,
        SupplierEventDetailComponent,
        CheckPaymentComponent,
        EmailSentToComponent,
        SupplierActivityFormComponent,
        DistributorActivityFormComponent,
        SupplierFeatureFormComponent,
        DistributorFeatureFormComponent,
        AdminTravelInfoFormComponent,
        AdminAddressFormComponent,
        AdminTravelDetailFormComponent,
        AdminLeisureFormComponent,
        SendMailComponent,
        ApproveRefundComponent,
        EditAdminProfileComponent,
        ChangeAdminPasswordComponent,
        EmailInvitationFormComponent,
        EmailContactFormComponent,
        EventPageFormComponent,
        SupplierMembershipFormComponent,
        PackageActivityLimitsComponent,
        PackageFeatureLimitsComponent,
        ActivityLimitFormComponent,
        FeatureLimitFormComponent,
        DistributorMembershipFormComponent,
        GuestMembershipFormComponent,
        EventFeatureFormComponent,
        FeatureOptionsComponent,
        FeatureOptionFormComponent,
        ActivityQuestionsComponent,
        ActivityQuestionFormComponent,
        ActivityQuestionOptionsComponent,
        ActivityQuestionOptionFormComponent,
        CardFormComponent,
        DeleteAttendeeWarningComponent,
        PayBalanceComponent,
        SupplierProfileComponent,
        AddAttendeeComponent,
        CancelAttendeeComponent,
        AddDiscountComponent,
        PayBalanceAdminComponent,
        SupplierAttendeeFormComponent,
        DistributorAttendeeFormComponent,
        EditSupplierAttendeeComponent,
        EditTravelComponent,
        EditDistributorAttendeeComponent,
        AdminEditAttendeeComponent,
        DistributorEditActivityComponent,
        AttendeesReportComponent,
        SupplierEditActivityComponent,
        AdminEditTravelInfoComponent,
        AttendeeEditActivityComponent,
        AdminFeatureEditComponent,
        FiltersPipe,
        AdminFullCancelComponent,
	GuestAttendeeFormComponent,
	EditGuestAttendeeComponent,
	GuestActivityFormComponent,
	EmailMessageComponent,
	GuestEditActivityComponent,
	CategoryPopUpComponent,
	TripRegistrationComponent,
        TripAddAttendeeComponent,
        TripEditAttendeeComponent,
        TripEditTravelComponent,
	EscapeHtmlPipe,
        TripEditActivityComponent,
        EditHotelCheckInOutComponent,
        FeedbackSentToComponent,
        SupplierRegTypesComponent,
        PurchaseOrderManualEntryFormComponent,
        GlobalPageFormComponent,
        AdminpackUpgradeComponent,
    ],
    entryComponents: [
        LoginComponent,
        CheckPaymentComponent,
        EmailSentToComponent,
        SupplierActivityFormComponent,
        DistributorActivityFormComponent,
        SupplierFeatureFormComponent,
        DistributorFeatureFormComponent,
        AdminTravelInfoFormComponent,
        AdminAddressFormComponent,
        AdminTravelDetailFormComponent,
        AdminLeisureFormComponent,
        SendMailComponent,
        ApproveRefundComponent,
        EditAdminProfileComponent,
        ChangeAdminPasswordComponent,
        EmailInvitationFormComponent,
        EmailContactFormComponent,
        EventPageFormComponent,
        SupplierMembershipFormComponent,
        PackageActivityLimitsComponent,
        PackageFeatureLimitsComponent,
        ActivityLimitFormComponent,
        FeatureLimitFormComponent,
        DistributorMembershipFormComponent,
        GuestMembershipFormComponent,
        EventFeatureFormComponent,
        FeatureOptionsComponent,
        FeatureOptionFormComponent,
        ActivityQuestionsComponent,
        ActivityQuestionFormComponent,
        ActivityQuestionOptionsComponent,
        ActivityQuestionOptionFormComponent,
        CardFormComponent,
        DeleteAttendeeWarningComponent,
        PayBalanceComponent,
        AddAttendeeComponent,
        CancelAttendeeComponent,
        AddDiscountComponent,
        PayBalanceAdminComponent,
        SupplierAttendeeFormComponent,
        DistributorAttendeeFormComponent,
        EditSupplierAttendeeComponent,
        EditTravelComponent,
        EditDistributorAttendeeComponent,
        AdminEditAttendeeComponent,
        DistributorEditActivityComponent,
        SupplierEditActivityComponent,
        AdminEditTravelInfoComponent,
        AttendeeEditActivityComponent,
        AdminFeatureEditComponent,
        AdminFullCancelComponent,
        GuestAttendeeFormComponent,
        EditGuestAttendeeComponent,
        GuestActivityFormComponent,
        EmailMessageComponent,
        GuestEditActivityComponent,
        CategoryPopUpComponent,
        TripAddAttendeeComponent,
        TripEditAttendeeComponent,
        TripEditTravelComponent,
        TripEditActivityComponent,
        EditHotelCheckInOutComponent,
        FeedbackSentToComponent,
	PurchaseOrderManualEntryFormComponent,
    GlobalPageFormComponent,
        AdminpackUpgradeComponent,
    ],
    imports: [
        BrowserModule,
        FormsModule,
        ReactiveFormsModule,
        HttpModule,
        BrowserAnimationsModule,
        NoopAnimationsModule,
        MyMaterialModule,
        AppRoutingModule,
        NgxPaginationModule,
        CustomFormsModule,
        FileUploadModule,
        ChartsModule,
        Ng2FilterPipeModule,
	CKEditorModule,
	TextMaskModule,
	MyDatePickerModule,
	DpDatePickerModule
    ],

    providers: [
        {
            provide: AuthHttp,
            useFactory: authHttpServiceFactory,
            deps: [Http, RequestOptions]
        },
        ValidationService,
        AuthenticationService,
        AuthGuard,
	Uploader
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}




// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/app.module.ts